import { CollapsableGroup } from '@/module/AnnualReport/components/CollapsableGroup';
import { AnnualReportAwards } from '@/module/AnnualReport/model/AnnualReportTypes';
import { AwardValidationAction } from '@/module/Author/Award/Validation/AwardValidationAction';
import { AwardCard } from '@/module/Author/Award/components/Card/AwardCard';

interface AnnualAwardsOverviewProps {
  awards: AnnualReportAwards;
}

export function AnnualAwardsOverview({ awards: { awards } }: AnnualAwardsOverviewProps) {
  return (
    <CollapsableGroup
      title="Premii câștigate"
      items={awards}
      renderValidation={award => (
        <AwardValidationAction
          variant="compact"
          awardId={award.id}
        />
      )}
      renderItem={award => (
        <AwardCard
          award={award}
          onClick={() => window.open(`/author/award/${award.id}`)}
        />
      )}
    />
  );
}
